var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.3C0 0.58203 0.58203 0 1.3 0H20.8C21.518 0 22.1 0.58203 22.1 1.3V18.2C22.1 18.918 21.518 19.5 20.8 19.5H1.3C0.58203 19.5 0 18.918 0 18.2V1.3ZM2.6 2.6V16.9H19.5V2.6H2.6Z",
    fill: "#5FFFA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 7.8C19.5 7.08203 20.082 6.5 20.8 6.5H26C26.3448 6.5 26.6754 6.63696 26.9192 6.88076L30.8192 10.7808C31.063 11.0246 31.2 11.3552 31.2 11.7V18.2C31.2 18.918 30.618 19.5 29.9 19.5H20.8C20.082 19.5 19.5 18.918 19.5 18.2V7.8ZM22.1 9.1V16.9H28.6V12.2385L25.4615 9.1H22.1Z",
    fill: "#5FFFA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14961 19.4999C6.07265 19.4999 5.19961 20.3729 5.19961 21.4499C5.19961 22.5269 6.07265 23.3999 7.14961 23.3999C8.22656 23.3999 9.09961 22.5269 9.09961 21.4499C9.09961 20.3729 8.22656 19.4999 7.14961 19.4999ZM2.59961 21.4499C2.59961 18.937 4.63671 16.8999 7.14961 16.8999C9.66251 16.8999 11.6996 18.937 11.6996 21.4499C11.6996 23.9628 9.66251 25.9999 7.14961 25.9999C4.63671 25.9999 2.59961 23.9628 2.59961 21.4499Z",
    fill: "#5FFFA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.05 19.4999C22.973 19.4999 22.1 20.3729 22.1 21.4499C22.1 22.5269 22.973 23.3999 24.05 23.3999C25.127 23.3999 26 22.5269 26 21.4499C26 20.3729 25.127 19.4999 24.05 19.4999ZM19.5 21.4499C19.5 18.937 21.5371 16.8999 24.05 16.8999C26.5629 16.8999 28.6 18.937 28.6 21.4499C28.6 23.9628 26.5629 25.9999 24.05 25.9999C21.5371 25.9999 19.5 23.9628 19.5 21.4499Z",
    fill: "#5FFFA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport);
export default __webpack_public_path__ + "static/media/transport.712dd2cb088f599d19b834f76cb9c8b0.svg";
export { ForwardRef as ReactComponent };